<template>
  <!--
    Gemeinsames Layout für /login und /register im Stil der Startseite (component/welcome.vue):
    links kurzer Text, rechts das Formular als Karte. Texte in src/content/authPages.js.
  -->
  <section class="auth">
    <v-container class="auth-wrap">
      <v-row align="center">
        <v-col cols="12" md="5" class="pr-md-10">
          <p class="auth-kicker">{{ kicker }}</p>
          <h1 class="auth-h1">{{ title }}</h1>
          <p class="auth-text">{{ text }}</p>
          <ul v-if="bullets.length" class="auth-checks">
            <li v-for="bullet in bullets" :key="bullet">
              <v-icon small color="success">mdi-check-circle</v-icon>
              <span>{{ bullet }}</span>
            </li>
          </ul>
        </v-col>
        <v-col cols="12" md="7">
          <div class="auth-card">
            <slot></slot>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'AuthLayout',

  props: {
    kicker: { type: String, default: '' },
    title: { type: String, required: true },
    text: { type: String, default: '' },
    bullets: { type: Array, default: () => [] }
  }
};
</script>

<style scoped>
/* Farben und Schriftgrößen wie auf der Startseite (component/welcome.vue) */
.auth {
  --ink: #1d2a1f;
  --muted: #526255;
  --green: #2e7d32;
  --line: #e1e9dd;
  min-height: 100%;
  padding: 32px 0 56px;
  background: linear-gradient(180deg, #eaf5e5 0%, #fff 70%);
  color: var(--ink);
}

.auth-wrap {
  max-width: 1080px;
}

.auth-kicker {
  margin-bottom: 0.75rem;
  color: var(--green);
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.auth-h1 {
  margin-bottom: 1rem;
  font-size: clamp(1.9rem, 3.6vw, 2.7rem);
  font-weight: 800;
  line-height: 1.12;
  letter-spacing: -0.02em;
}

.auth-text {
  color: var(--muted);
  font-size: 1.1rem;
  line-height: 1.65;
}

.auth-checks {
  margin: 16px 0 0;
  padding: 0 !important;
  list-style: none;
}

.auth-checks li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 5px 0;
  line-height: 1.5;
}

.auth-checks .v-icon {
  margin-top: 3px;
}

.auth-card {
  padding: 28px;
  border: 1px solid var(--line);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 22px 44px -24px rgba(20, 45, 20, 0.35);
}

/* Gemeinsame Bausteine für die Formulare in login.vue und register.vue */
.auth-card >>> .auth-card-title {
  margin-bottom: 20px;
  font-size: 1.35rem;
  font-weight: 700;
}

.auth-card >>> .auth-type {
  display: flex;
  width: 100%;
  margin-bottom: 24px;
}

.auth-card >>> .auth-type .v-btn {
  flex: 1 1 50%;
  height: 44px !important;
  text-transform: none;
  letter-spacing: 0;
  font-size: 1rem;
}

.auth-card >>> .auth-switch {
  margin: 20px 0 0;
  color: var(--muted);
  text-align: center;
}

.auth-card >>> .auth-link {
  color: var(--green) !important;
  font-weight: 600;
  text-decoration: none;
}

.auth-card >>> .auth-link:hover {
  text-decoration: underline;
}

@media (min-width: 960px) {
  .auth {
    padding: 72px 0 88px;
  }

  .auth-card {
    padding: 36px;
  }
}
</style>
